import { MatrixOrder } from '@/models/matrix-order.model';
import type { DraftModel } from '@onrunning/backstage-models';
import { useSessionStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import type { Order } from '../models/order.model';

export const useAddEditOrderStore = defineStore('add-edit-order', () => {
  // state
  const selectedProductModels = useSessionStorage<string[]>('addEditOrder/selectedProductModels', []);
  const editingMatrixOrders = useSessionStorage<MatrixOrder[]>('addEditOrder/editingMatrixOrders', []);
  const editingOrders = useSessionStorage<Order[] | DraftModel[]>('addEditOrder/editingOrders', []);
  const initialCustomerPoNumber = useSessionStorage<string | undefined>(
    'addEditOrder/initialCustomerPoNumber',
    undefined,
  );

  // getters

  function getInitialCustomerPoNumber() {
    return initialCustomerPoNumber.value;
  }

  // actions
  function setSelectedProductModels(productModels: string[]) {
    selectedProductModels.value = productModels;
  }

  function removeSelectedProductModels() {
    selectedProductModels.value = [];
  }

  function setEditingMatrixOrders(matrixOrders: MatrixOrder[]) {
    editingMatrixOrders.value = matrixOrders;
  }

  function removeEditingMatrixOrders() {
    editingMatrixOrders.value = [];
  }

  function setEditingOrders(orders: Order[] | DraftModel[]) {
    editingOrders.value = orders;
  }

  function setInitialCustomerPoNumber(customerPoNumber: string | undefined) {
    initialCustomerPoNumber.value = customerPoNumber;
  }

  function removeEditingOrders() {
    editingOrders.value = [];
  }

  function $reset() {
    editingOrders.value = [];
    editingMatrixOrders.value = [];
    selectedProductModels.value = [];
    initialCustomerPoNumber.value = undefined;
  }

  return {
    selectedProductModels,
    editingMatrixOrders,
    editingOrders,
    initialCustomerPoNumber,
    setSelectedProductModels,
    setEditingMatrixOrders,
    setEditingOrders,
    getInitialCustomerPoNumber,
    removeEditingMatrixOrders,
    removeEditingOrders,
    removeSelectedProductModels,
    setInitialCustomerPoNumber,
    $reset,
  };
});
